import { useQuery } from "@tanstack/react-query";
import { apiList } from "./api";
import type { Submission } from "./types";

/** Counts of items needing action, keyed by the nav path they belong to.
 *  Polls so the badges stay live. Server-side scoping means an MDA user only
 *  ever counts their own drafts; NBS sees the validation/change-request queues. */
export function useActionCounts(): Record<string, number> {
  const subs = useQuery({
    queryKey: ["counts-subs"], refetchInterval: 15000,
    queryFn: () => apiList<Submission>("/api/submissions/").catch(() => [] as Submission[]),
  });
  const crs = useQuery({
    queryKey: ["counts-crs"], refetchInterval: 15000,
    queryFn: () => apiList<any>("/api/change-requests/").catch(() => [] as any[]),
  });

  const s = subs.data ?? [];
  const drafts = s.filter((x) => x.status === "draft" || x.status === "returned").length;
  const awaiting = s.filter((x) => x.status === "submitted" || x.status === "under_review").length;
  const pendingCrs = (crs.data ?? []).filter((c: any) => c.status === "pending").length;

  return {
    "/agency/submissions": drafts,
    "/nbs/validation": awaiting,
    "/nbs/change-requests": pendingCrs,
  };
}
